import React, { useEffect } from "react";
import { BillingHistory } from "./BillingHistory";
import { Balance } from "./Balance";
import styles from "./Billing.module.css";
import classNames from "classnames";
import ProgressOverlay from "Components/progressOverlay";
export default function Billing({ inProgress, onInitialized }) {
    useEffect(() => {
        onInitialized();
    }, []);
    return (React.createElement(ProgressOverlay, { show: inProgress },
        React.createElement("div", { className: classNames(styles.container, "panel-body-padding") },
            React.createElement(Balance, null),
            React.createElement(BillingHistory, null))));
}
